// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"505":"80da3cf7","594":"599b1ec8"}[chunkId] + ".js";
};